import createReducerExtended from 'utils/createReducerExtended';

import {
  CREATE_NOTIFICATION_MESSAGE,
  DELETE_NOTIFICATION_MESSAGE,
} from '../constants';
import { initialState } from '../schema';
import * as reduceCreateNotificationMessage from './reduceCreateNotificationMessage';
import * as reduceDeleteNotificationMessage from './reduceDeleteNotificationMessage';

export const reducer = (state = initialState, action) =>
  createReducerExtended(
    state,
    action,
    { CREATE_NOTIFICATION_MESSAGE, DELETE_NOTIFICATION_MESSAGE },
    {
      ...reduceCreateNotificationMessage,
      ...reduceDeleteNotificationMessage,
    },
  );
